import React from "react";
import { useLocation } from "react-router-dom";
function Sidebar({ open, onClose, sidebarItems, iconMap, headerOffset = 80, collapsedWhenClosed = false }) {

  const [hoveredIdx, setHoveredIdx] = React.useState(-1);

  const resultPage = useLocation().pathname.includes('/results');

  const renderIcon = (label, isActive) => {
    const iconEntry = iconMap ? iconMap[label] : null;
    const color = isActive ? '#181A1B' : '#7b8a92';
    const size = 20;
    if (!iconEntry) return <span />;
    if (React.isValidElement(iconEntry)) {
      return React.cloneElement(iconEntry, { color, size });
    }
    if (typeof iconEntry === 'function') {
      const IconComp = iconEntry;
      return <IconComp color={color} size={size} />;
    }
    return <span />;
  };

  // Mini sidebar (icons only)
  const MiniSidebar = (
    <div
      style={{
        position: 'fixed',
        top: headerOffset,
        left: 0,
        width: 56,
        height: `calc(100vh - ${headerOffset}px)`,
        background: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 12,
        borderRight: '1px solid #d9e2e8',
        overflowY: 'auto',
        cursor: 'pointer',
        transition: 'width 0.2s',
      }}
      onClick={onClose ? () => onClose(true) : undefined}
      aria-label="Open sidebar"
    >
      {sidebarItems.map((item, idx) => {
        if (item === 'divider') return null;
        const icon = item.label === 'English'
          ? <img

            src="https://www.kayak.com/res/images/flags-svg/us.svg"

            alt="United States (English)"

            width={20}

            height={20}

            style={{ display: 'block', border: '1px solid #dfe6ea', borderRadius: 2, marginTop: 2 }}

          />
          : renderIcon(item.label, !!item.active);
        return (
          <div
            key={item.label}
            style={{
              width: 40,
              height: 40,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '8px 0',
              background: item.active ? '#f3f5f6' : 'none',
              borderRadius: 8,
            }}
          >
            {icon}
          </div>
        );
      })}
    </div>
  );

  // Single expanding sidebar: mini (56px) collapsed, 240px expanded
  const drawerWidth = open ? 240 : (collapsedWhenClosed ? 56 : 0);
  const SidebarDrawer = (
    <div className="kayak-sidebar-scroll" style={{
      position: 'fixed',
      top: headerOffset,
      left: 0,
      width: drawerWidth,
      height: `calc(100vh - ${headerOffset}px)`,
      background: '#fff',
      boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
      borderRight: '1px solid #e6ecef',
      zIndex: resultPage ? 99 : 1000,
      display: 'flex',
      flexDirection: 'column',
      padding: '6px 0',
      borderBottomRightRadius: 12,
      overflowY: 'auto',
      transition: 'width 180ms cubic-bezier(0,0,0.4,1)',
    }}>
      <div style={{ padding: '0px 8px' }}>

        {sidebarItems.map((rawItem, idx) => {
          if (rawItem === 'divider') {
            return <div key={`div-${idx}`} style={{ width: '100%', height: 1, background: '#e3e7ea', margin: '10px 0' }} />;
          }
          const item = typeof rawItem === 'string' ? { label: rawItem } : rawItem;
          const isActive = !!item.active;
          const isHovered = hoveredIdx === idx;

          const labelStyle = {
            flex: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontWeight: isActive ? 600 : 500,
            color: isActive ? '#181A1B' : '#5b6a72',
            fontSize: 13,
            maxWidth: open ? 160 : 0,
            opacity: open ? 1 : 0,
            transition: 'max-width 180ms cubic-bezier(0,0,0.4,1), opacity 120ms ease',
          };

          const icon = item.label === 'English'
            ? (
                <img
                  src="https://www.kayak.com/res/images/flags-svg/us.svg"
                  alt="United States (English)"
                  width={18}
                  height={12}
                  style={{ display: 'block', border: '1px solid #dfe6ea', borderRadius: 2 }}
                />
              )
            : renderIcon(item.label, isActive);

          const badgeStyleBase = {
            borderRadius: "4px",
            padding: '1px 4px',
            fontSize: 11,
            lineHeight: "14px",
            fontWeight: 500,
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
          };

          const badge = item.badge === 'BETA'

            ? <span style={{ ...badgeStyleBase, color: '#fff', border: '1px solid #dfe6ea', background: '#363f45' }}>BETA</span>

            : item.badge === 'NEW'

              ? <span style={{ ...badgeStyleBase, color: '#fff', border: '1px solid #dfe6ea', background: '#363f45' }}>NEW</span>

              : null;

          return (
            <div
              key={`${item.label}-${idx}`}

              role="button"
              style={{

                display: 'flex',

                alignItems: 'center',

                gap: 12,

                cursor: 'pointer',

                textDecoration: 'none',

                padding: '8px',

                margin: '2px 0',

                borderRadius: 4,

                maxWidth: '100%',

                transition: 'max-width 180ms cubic-bezier(0,0,0.4,1)',

                transitionBehavior: 'normal',

                transitionDuration: '180ms',

                transitionTimingFunction: 'cubic-bezier(0, 0, 0.4, 1)',

                transitionDelay: '0s',



                background: isActive ? '#e6ebef' : (isHovered ? '#f7f9fb' : 'transparent'),

                position: 'relative',

                outline: 'none',

              }}

              tabIndex={-1}

              onMouseEnter={() => setHoveredIdx(idx)}

              onMouseLeave={() => setHoveredIdx(-1)}

              onMouseDown={(e) => e.preventDefault()}
            >
              {/* Removed blue active border bar to match requested design */}
              <div style={{ width: 26, height: 26, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {renderIcon(item.label, isActive || isHovered, item.icon)}
              </div>
              <span style={{

                ...labelStyle,

                color: isActive || isHovered ? '#181A1B' : '#5b6a72',



              }}>{item.label}</span>
              {badge}
            </div>
          );
        })}
      </div>
    </div>
  );

  // Overlay for closing sidebar (only when open)
  const SidebarOverlay = (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        top: headerOffset,
        left: 0,
        width: '100vw',
        height: `calc(100vh - ${headerOffset}px)`,
        background: 'rgba(0,0,0,0.2)',
        zIndex: 1000,
        animation: 'fadeInBackgroundLTR cubic-bezier(0,0,0.4,1) 180ms forwards',
      }}
    />
  );

  return (
    <>
      <style>{`
        .kayak-sidebar-scroll { -ms-overflow-style: none; scrollbar-width: none; }
        .kayak-sidebar-scroll::-webkit-scrollbar { width: 0; height: 0; }
        @keyframes fadeInBackgroundLTR {
          0% { opacity: 0; left: 0; }
          100% { opacity: 1; left: 240px; }
        }
      `}</style>
      {/* Single component that collapses/expands; overlay only when expanded */}
      {open && SidebarOverlay}
      {SidebarDrawer}
    </>
  );
}

export default Sidebar; 